"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gtm_1 = require("../utils/gtm");
class BaseEvent {
    sendGtmEvent(eventName, args) {
        (0, gtm_1.pushGtmEvent)(eventName, args);
    }
    sendSegmentEvent(eventName, args) {
        (0, gtm_1.track)(eventName, args);
    }
}
exports.default = BaseEvent;
//# sourceMappingURL=BaseEvent.js.map